const Blockly = require('blockly');
//The default blockly (v8) doesn't support nonce
//This is a copy from 2 files as specified to add the nonce
//primary change is noted below, to add the nonce
//secondary change is changing `content` to `Blockly.Css.content` and `Blockly.utils.depreciation`

/*********** node_modules\blockly\core\css.js **********/
/**
 * Has CSS already been injected?
 * @type {boolean}
 * @private
 */
let injected = false;

/**
 * Inject the CSS into the DOM.  This is preferable over using a regular CSS
 * file since:
 * a) It loads synchronously and doesn't force a redraw later.
 * b) It speeds up loading by not blocking on a separate HTTP transfer.
 * c) The CSS content may be made dynamic depending on init options.
 * @param {boolean} hasCss If false, don't inject CSS
 *     (providing CSS becomes the document's responsibility).
 * @param {string} pathToMedia Path from page to the Blockly media directory.
 * @alias Blockly.Css.inject
 */
Blockly.Css.inject = function (hasCss, pathToMedia) {
    // Only inject the CSS once.
    if (injected) {
        return;
    }
    injected = true;
    if (!hasCss) {
        return;
    }
    // Strip off any trailing slash (either Unix or Windows).
    const mediaPath = pathToMedia.replace(/[\\/]$/, '');
    const cssContent = Blockly.Css.content.replace(/<<<PATH>>>/g, mediaPath);
    // Cleanup the collected css content after injecting it to the DOM.
    Blockly.Css.content = '';

    // Inject CSS tag at start of head.
    const cssNode = document.createElement('style');
    cssNode.id = 'blockly-common-style';
    //the following lines is the only change made:
    const nonce = window?.NONCE_ID;
    if (nonce != null) {
        cssNode.setAttribute('nonce', nonce);
    }
    //end change
    const cssTextNode = document.createTextNode(cssContent);
    cssNode.appendChild(cssTextNode);
    document.head.insertBefore(cssNode, document.head.firstChild);
};

//no changes to this function, but it shares a global variable "injected" with inject
/**
 * Add some CSS to the blob that will be injected later.  Allows optional
 * components such as fields and the toolbox to store separate CSS.
 * @param {string|!Array<string>} cssContent Multiline CSS string or an array of
 *    single lines of CSS.
 * @alias Blockly.Css.register
 */
Blockly.Css.register = function (cssContent) {
    if (injected) {
        throw Error('CSS already injected');
    }

    if (Array.isArray(cssContent)) {
        Blockly.utils.deprecation.warn(
            'Registering CSS by passing an array of strings',
            'September 2021',
            'September 2022',
            'css.register passing a multiline string'
        );
        Blockly.Css.content += '\n' + cssContent.join('\n');
    } else {
        // Add new cssContent in the global content.
        Blockly.Css.content += '\n' + cssContent;
    }
};

/*********node_modules\blockly\core\renderers\common\constants.js********/
/**
 * Inject renderer specific CSS into the page.
 * @param {string} tagName The name of the style tag to use.
 * @param {string} selector The CSS selector to use.
 * @protected
 */
Blockly.blockRendering.ConstantProvider.prototype.injectCSS_ = function (tagName, selector) {
    const cssArray = this.getCSS_(selector);
    const cssNodeId = 'blockly-renderer-style-' + tagName;
    this.cssNode_ = /** @type {!HTMLStyleElement} */ (document.getElementById(cssNodeId));
    const text = cssArray.join('\n');
    if (this.cssNode_) {
        // Already injected, update if the theme changed.
        this.cssNode_.firstChild.textContent = text;
        return;
    }
    // Inject CSS tag at start of head.
    const cssNode = /** @type {!HTMLStyleElement} */ (document.createElement('style'));
    cssNode.id = cssNodeId;
    //the following lines is the only change made:
    const nonce = window?.NONCE_ID;
    if (nonce != null) {
        cssNode.setAttribute('nonce', nonce);
    }
    //end change
    const cssTextNode = document.createTextNode(text);
    cssNode.appendChild(cssTextNode);
    document.head.insertBefore(cssNode, document.head.firstChild);
    this.cssNode_ = cssNode;
};
